import gql from 'graphql-tag';

export const SKIP_WORKLETS_WITH_TRACKER_MUTATION = gql`
  mutation SkipWorkletsWithTrackerMutation($programId: Int!, $workletSpecKey: String!) {
    parentJobId: skipWorkletsWithTracker(workletSpecKey: $workletSpecKey, programId: $programId)
  }
`;
